import React from 'react';
import {
  Container,
  CountBox,
  IBox,
  Title,
  Content,
} from 'styles/pages/dashboard/orderSummary';

const OrderSummary = ({ user }) => {
  return (
    <Container>
      <CountBox>
        <IBox>
          <Title>Total Shipped</Title>
          <Content>{user?.totalShippedOrders}</Content>
        </IBox>
        <IBox>
          <Title>Total Orders</Title>
          <Content>{user?.totalOrders}</Content>
        </IBox>
      </CountBox>
    </Container>
  );
};

export default OrderSummary;
